'use client'

import { useRef } from 'react'

import styles from './richText.module.css'

type Props = {
  src: string
  srcSet?: string
  sizes?: string
  fullSrc: string
  alt: string
  width?: number | null
  height?: number | null
  labels: { enlargeImage: string; close: string }
}

// Responsive image that opens the full-size file in a modal on click (keyboard accessible, Esc closes).
export function ZoomableImage({ src, srcSet, sizes, fullSrc, alt, width, height, labels }: Props) {
  const dialog = useRef<HTMLDialogElement>(null)
  const full = useRef<HTMLImageElement>(null)

  const open = () => {
    if (full.current && !full.current.getAttribute('src')) full.current.setAttribute('src', fullSrc)
    dialog.current?.showModal()
  }

  return (
    <>
      <button type="button" className={styles.imageButton} onClick={open} aria-label={`${labels.enlargeImage}: ${alt}`} data-testid="zoomable-image">
        {/* eslint-disable-next-line @next/next/no-img-element -- CMS uploads with their own responsive sizes */}
        <img src={src} srcSet={srcSet} sizes={sizes} alt={alt} width={width ?? undefined} height={height ?? undefined} loading="lazy" decoding="async" />
      </button>
      <dialog ref={dialog} className={`${styles.modal} ${styles.imageModal}`} aria-label={alt} onClick={(e) => e.target === dialog.current && dialog.current?.close()} data-testid="image-modal">
        <div className={styles.modalHeader}>
          <strong>{alt}</strong>
          <button type="button" className={styles.modalClose} onClick={() => dialog.current?.close()} aria-label={labels.close}>
            ✕
          </button>
        </div>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img ref={full} alt={alt} className={styles.imageFull} />
      </dialog>
    </>
  )
}
